export const RIFieldsLive = {
  url: 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
  oid: '00D4L000000CplT',
  uprn: '00N4L000000Q40C',
  leadSource: 'lead_source',
  street: 'street',
  city: 'city',
  zip: 'zip',
  state: 'state',
  country: 'country',
  firstName: 'first_name',
  lastName: 'last_name',
  email: 'email',
  phone: 'phone',
  company: 'company',
  hearAboutUs: '00N4L000006YWi6',
  provider: '00N4L000000Pymm',
  endDate: '00N4L000000Pyml',
  communicationPreference: '00N4L000003AE5u',
  orderable: '00N8d000008SGgt',
  message: '00N8d00000KxqE0',
  ambassador: '00N8d00000KxqDz',
  otherSource: '00N8d00000KxqE1',
  region: '00N8d00000Kxwgi',
  referralCode: '00N8d00000Ky0qX',
  latitude: '00N8d00000VAdeW',
  longitude: '00N8d00000VAdeX',
  salesNotes: '00N8d00000VDQYS',
  followUpDate: '00N8d00000VDQYR',
  leadType: '00NTv000002lenF',
  humanHelpMessage: '00N8d00000KxqE0',
  alreadyCustomer: '00NTv000004dccb',
  gclid: '00NTv0000064L2W',

  // business specific
  businessOrderable: '00N4L000003BnCm',
  managedNetworkSwitch: '00NTv000005YsGG',
  brandManagedNetworkSwitch: '00NTv000005YsGa',
  companyName: '00NTv000005YsGb',
  companyNumber: '00NTv000005YsGc',
  posSystem: '00NTv000005giOM',
  independantBusiness: '00NTv000005YsGH',
  litLeadType: '00NTv000005YsGI',
  itExpertise: '00NTv000005YsGJ',
  numberStaff: '00NTv000005YsGK',
  siteToSiteVPN: '00NTv000005YsGL',
  primarySecondaryConnection: '00NTv000005YsGM',
  externalStaticIP: '00NTv000005YsGN',
  alternativeContact2Phone: '00NTv000005YsGU',
  alternativeContact2Email: '00NTv000005YsGV',
  alternativeContact2Role: '00NTv000005YsGW',
  alternativeContactEmail: '00NTv000005YsGX',
  alternativeContactPhone: '00NTv000005YsGY',
  alternativeContactRole: '00NTv000005YsGZ',
  currentlyMonthlyBill: '00NTv000005YsGd',
  primaryContactRole: '00NTv000005ce4o',
  vatNumber: '00NTv000005ce4p',
  vatRegistered: '00NTv000005YsGO',
  contractEndDate: '00N4L000000Pyml',
  currentProvider: '00N4L000000Pymm',
  contactPreferences: '00N4L000003AE5u',
  numberProperties: '00NTv000005giOP',
  cutomerTimeOnPremises: '00NTv000005YsGE',
  requireStaticIp: '00NTv000005giON',
  accountHolderAlwaysOnSite: '00NTv000005YsGD',
  registeredAddressDifferent: '00NTv000005qGVe',
  posSystemType: '00NTv000006Arly',
  litContactType: '00NTv000005YsGC',
  propertyOwnership: '00NTv000006Hvw6',
};

export const RIFieldsUAT = {
  ...RIFieldsLive,
  url: 'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
  oid: '00D8E000000IE5R',
  uprn: '00N4L000000Q40C',
  hearAboutUs: '00N4L000006YWi6',
  provider: '00N4L000000Pymm',
  endDate: '00N4L000000Pyml',
  communicationPreference: '00N4L000003AE5u',
  orderable: '00N8d000008SGgt',
  message: '00N8d00000KxqE0',
  ambassador: '00N8d00000KxqDz',
  otherSource: '00N8d00000KxqE1',
  region: '00N8d00000Kxwgi',
  referralCode: '00N8d00000Ky0qX',
  latitude: '00N8d00000VAdeW',
  longitude: '00N8d00000VAdeX',
  salesNotes: '00N8E00000Ec1kl',
  followUpDate: '00N8E00000Ec1kv',
  leadType: '00NUE000001MMHR',
  humanHelpMessage: '00N8d00000KxqE0',
  alreadyCustomer: '00NUE000001vlT3',
  gclid: '00NUE000002UFGb',

  // BUSINESS SPECIFIC
  businessOrderable: '00N4L000003BnCm',
  managedNetworkSwitch: '00NUE000002JKzu',
  brandManagedNetworkSwitch: '00NUE000002JKzp',
  companyName: '00NUE000002JKzq',
  companyNumber: '00NUE000002JKzr',
  posSystem: '00NUE000002LyBJ',
  independantBusiness: '00NUE000002JKzv',
  litLeadType: '00NUE000002JKzw',
  itExpertise: '00NUE000002JKzx',
  numberStaff: '00NUE000002JKzy',
  siteToSiteVPN: '00NUE000002JKzz',
  primarySecondaryConnection: '00NUE000002JL00',
  externalStaticIP: '00NUE000002JL01',
  alternativeContact2Phone: '00NUE000002Jfxa',
  alternativeContact2Email: '00NUE000002Jfxb',
  alternativeContact2Role: '00NUE000002Jfxc',
  alternativeContactEmail: '00NUE000002Jfxd',
  alternativeContactPhone: '00NUE000002Jfxe',
  alternativeContactRole: '00NUE000002Jfxf',
  currentlyMonthlyBill: '00NUE000002Jfxg',
  primaryContactRole: '00NUE000002Jy7N',
  vatNumber: '00NUE000002K6Pt',
  vatRegistered: '00NUE000002JL02',
  contractEndDate: '00N4L000000Pyml',
  currentProvider: '00N4L000000Pymm',
  contactPreferences: '00N4L000003AE5u',
  numberProperties: '00NUE000002LXfU',
  cutomerTimeOnPremises: '00NUE000002JKzs',
  requireStaticIp: '00NUE000002LyBK',
  accountHolderAlwaysOnSite: '00NUE000002JKzo',
  registeredAddressDifferent: '00NUE000002ReWU',
  posSystemType: '00NUE000002Xi18',
  litContactType: '00NUE000002JfxZ',
  propertyOwnership: '00NUE000002ahV8',
};
